import React from "react";
import { Section, Text } from "@/components";
import "./Symptoms.scss";

const symptomsData = [
  "Excessive time spent reviewing investment documents",
  "Difficulty identifying where to probe further or which questions to prioritize",
  "Wasting effort on companies that are not a match for your investment criteria",
  "Frustration with LLMs that can’t handle Excel workbooks",
  "Inability to use AI tools due to security and privacy restrictions",
  "Red flags missed, or spotted too late, during the diligence process"
]

export const SymptomItem = ({text} : {text: string}): JSX.Element => {
  return (
    <div className="flex">
      <img
        className="w-6 h-6 object-contain"
        alt="Symptom Icon"
        src="/images/home/red-circle.svg"
        loading="lazy"
      />
      
      <div className="flex flex-col items-center sm:items-start ml-3">
        <Text.Description size="xs" className="text-[#D7D7D7] text-[16px] font-[400] md:!font-[300] font-inter symptom-item-title">
          {text}
        </Text.Description>
      </div>
    </div>
  );
};

export const SymptomsSection = (): JSX.Element => {
  return (
    <Section className="px-5 bg-black">
      <div>
        <div className="flex flex-col text-center gap-y-1">
          <div className="flex justify-center gap-1">
            <Text.Heading size="xl" className="symptom-title symptom-sub-title-gradient md:!text-[65px] !font-400 font-calSans">
              Symptoms of an
            </Text.Heading>&nbsp;
            <Text.Heading size="xl" className="symptom-title symptom-inefficient-title md:!text-[65px] !font-400 font-calSans">
              Inefficient
            </Text.Heading>
          </div>

          <Text.Heading size="2xl" className="text-[48px] md:!text-[100px] leading-[62px] md:leading-[125px] !font-400 font-calSans symptom-sub-title symptom-sub-title-gradient">
            Diligence Process
          </Text.Heading>

          <Text.Description size="sm" className="hidden md:block font-normal text-center mt-4 !text-[#BDBDBD] md:!text-white !leading-[20px] md:!leading-[26px]">
            Even the most sophisticated firms encounter friction in the diligence process. <strong>Are you facing:</strong>
          </Text.Description>

          <div className="flex flex-col md:hidden gap-0">
            <Text.Description size="sm" className="font-normal text-center !text-[#BDBDBD] md:!text-white !leading-[20px] md:!leading-[26px]">
              Even the most sophisticated firms encounter
            </Text.Description>
            <Text.Description size="sm" className="font-normal text-center !text-[#BDBDBD] md:!text-white !leading-[20px] md:!leading-[26px]">
              friction in the diligence process. <strong>Are you facing:</strong>
            </Text.Description>
          </div>
        </div>

        <div className="max-w-[814px] mt-6">
          <div className="symptoms-options hidden md:block bg-[#141519] rounded-[14px]">
            {/* desktop screen */}
            <div className="py-10 px-2">
              <div className="flex">
                <div className="flex-1 px-8 grid gap-5 border-r border-[#2B2D39]">
                  {symptomsData.slice(0, 3).map((symptom, index) => (
                    <SymptomItem key={index} text={symptom} />
                  ))}
                </div>
                <div className="flex-1 px-8 grid gap-5">
                  {symptomsData.slice(3).map((symptom, index) => (
                    <SymptomItem key={index} text={symptom} />
                  ))}
                </div>
              </div>

            </div>
          </div>
          <div className="mobile-symptoms-options block md:hidden">
            {/* mobile screen */}
            <div className="mobile-symptoms-options-content">
              <div className="grid gap-5">
                {symptomsData.map((symptom, index) => (
                  <SymptomItem key={index} text={symptom} />
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-black mb-[20px] md:mb-[60px]"></div>
      </div>
    </Section>
  );
};
